// extracted by mini-css-extract-plugin
export default {"wrapper":"Column_wrapper__m8FHr","centerX":"Column_centerX__jkEHM","centerY":"Column_centerY__GpRa+","spaceBetween":"Column_spaceBetween__Rq6sJ","scroll":"Column_scroll__9LDs1"};